module.exports = __webpack_public_path__ + "media/Instruction_41.12635250.mp3";